import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';
import { useRestrictedAccess } from '~portal/hooks';
import { guardRestrictedSection } from './-guard';

/**
 * @desc The Restricted section (round 3, lane 11, H2-314): staging-only, admin-only pages for
 * reviewing prototypes, starting with Experiments.
 *
 * Three layers, none of them the real boundary on its own:
 * - `beforeLoad` makes the section not exist where the flag is unset (production): `notFound()`,
 *   exactly as an unknown path. The standalone build sends it to chat, as every product route.
 * - The layout refuses a signed-in non-admin by sending them Home. It runs inside the protected
 *   layout, which renders children only once AuthKit has settled, so the token claims are already
 *   resolved here — `beforeLoad` cannot see them (AuthKit state is React state, not router context).
 * - The edge middleware (`decideEdgeAccess`) refuses a direct page load without a verified admin
 *   token, or with the flag unset in the edge environment.
 *
 * The pages hold no data of their own: anything an experiment shows comes from admin-only (`AP`)
 * procedures that check `isAdmin` again in the service, which is the authoritative gate.
 */
export const Route = createFileRoute('/_protected/restricted')({
  beforeLoad: guardRestrictedSection,
  component: RestrictedLayout,
});

function RestrictedLayout() {
  const allowed = useRestrictedAccess();
  if (!allowed) return <Navigate to="/" replace />;
  return <Outlet />;
}
